module.exports = __webpack_public_path__ + "static/media/supermarket-3.f0167d12.png";